<template>
  <div class="analysis-configuration-container">
    <h2 class="analysis-configuration-title">Configuração da análise</h2>

    <v-menu v-model="menu" :disabled="loadingAnalyticConfigurations" eager bottom offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <div class="analysis-configuration-select" v-on="on">
          <analysis-configuration-line :analysis-configuration="selectedAnalyticConfigration" :loading="loadingAnalyticConfigurations" />
        </div>
      </template>

      <v-card class="select-card">
        <ul v-if="analysisConfigurations && analysisConfigurations.length > 1">
          <li
            v-for="analysisConfiguration in analysisConfigurations"
            :key="analysisConfiguration.id"
            class="select-card-item-list"
            @click="handleSelectAnalysis(analysisConfiguration._id)"
          >
            <analysis-configuration-line :analysis-configuration="analysisConfiguration" hide-arrow />
          </li>
        </ul>
        <div v-else class="select-card-empty-state">
          <p>Nenhuma análise personalizada criada.</p>
          <mf-button
            :disabled="!$permissions.havePagePermission('gerenciador-analises')"
            label="Gerenciador de análises"
            icon="open_in_new"
            icon-position="right"
            color="marca-0-l40"
            @click="goToHub"
          />
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import AnalysisConfigurationLine from './AnalysisConfigurationLine.vue'
import { rfvAnalysis } from '../../mixins/analise-rfv'
import { mapGetters } from 'vuex'

export default {
  name: 'AnalysisConfiguration',
  components: { AnalysisConfigurationLine },
  mixins: [rfvAnalysis],
  props: {
    isDre: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    ...mapGetters(['dreAnalyticConfigurations', 'units', 'loadingAnalyticConfigurations']),
    analysisConfigurations() {
      if (!this.rfvAnalyticConfigurations?.length && !this.dreAnalyticConfigurations?.length) return []
      const configurations = this.isDre ? this.dreAnalyticConfigurations : this.rfvAnalyticConfigurations
      return configurations.map((analysis) => {
        return {
          _id: analysis?._id,
          type: analysis?.recurrent ? 'RECURRENT' : 'NOT_RECURRENT',
          title: analysis?.title,
          description: this.getAnalysisDescription(analysis),
          units: analysis?.filters?.units?.length === 0 ? this.units.length : analysis?.filters?.units?.length,
          personType: this.getAnalysisPersonType(analysis),
          products: analysis?.filters?.products?.length || 0,
          offersScheduleIds: analysis?.filters?.offersScheduleIds?.length || 0,
        }
      })
    },
    selectedAnalyticConfigration() {
      return this.analysisConfigurations.find((analysis) => analysis._id === this.analyticsConfiguration._id)
    },
  },
  methods: {
    getAnalysisDescription(analysis) {
      if (analysis?.notRecurrent) return 'Análise isolada'
      return analysis?.recurrent?.modelType === 'MONTHLY'
        ? 'Análise recorrente - Mensal'
        : `Análise recorrente - Semanal | ${this.getDaysRange(analysis?.recurrent?.initialWeekDay)}`
    },
    getAnalysisPersonType(analysis) {
      const { clientsType } = analysis?.filters
      if (!clientsType || !clientsType?.length || clientsType?.length === 2) return null
      return clientsType[0]
    },
    handleSelectAnalysis(analysisId) {
      const configurations = this.isDre ? this.dreAnalyticConfigurations : this.rfvAnalyticConfigurations
      const selectedAnalysis = configurations.find((analysis) => analysis._id === analysisId)
      this.$emit('change-analysis-configuration', selectedAnalysis)
      this.menu = false
    },
    goToHub() {
      const routeData = this.$router.resolve({ path: '/gerenciador-analises' })

      window.open(routeData.href, '_blank')
    },
    getDaysRange(startDay = '') {
      const daysRange = {
        MONDAY: 'Seg ~ Dom',
        TUESDAY: 'Ter ~ Seg',
        WEDNESDAY: 'Qua ~ Ter',
        THURSDAY: 'Qui ~ Qua',
        FRIDAY: 'Sex ~ Qui',
        SATURDAY: 'Sáb ~ Sex',
        SUNDAY: 'Dom ~ Sáb',
        '': '',
      }

      return daysRange[startDay]
    },
  },
}
</script>

<style lang="scss" scoped>
.analysis-configuration-container {
  .analysis-configuration-title {
    color: $marca-0;
    font-size: 16px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 0.4px;
    margin-bottom: 12px;
  }

  .analysis-configuration-select {
    width: 100%;
    border-radius: 8px;
    border: 1px solid $marca-0-l10;
    padding: 6px 12px;
    background-color: $branco;
    cursor: pointer;
  }
}

::v-deep .select-card {
  ul {
    padding: 0;
    list-style: none;

    .select-card-item-list {
      padding: 6px 12px;
      border-bottom: 1px solid $cinza-l50;

      &:hover {
        background-color: $cinza-l90;
      }
    }

    .select-card-item-list:last-child {
      border-color: transparent;
    }
  }

  .select-card-empty-state {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;

    p {
      color: $cinza-d20;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
